import React from 'react';
import './landing/landing.css';
import LandingNavbar from './landing/LandingNavbar';
import Hero from './landing/Hero';
import RecentMatches from './RecentMatches';
import WhoIsThisFor from './landing/WhoIsThisFor';
import Features from './landing/Features';
import HowItWorks from './landing/HowItWorks';
import LandingFAQ from './landing/LandingFAQ';
import FinalCTA from './landing/FinalCTA';
import LandingFooter from './landing/LandingFooter';
import useScrollReveal from './landing/useScrollReveal';

const Home = () => {
  useScrollReveal();

  return (
    <div className="cf-landing">
      <LandingNavbar />
      <Hero />
      <RecentMatches /> 
      <WhoIsThisFor />
      <Features />
      <HowItWorks />
      <LandingFAQ />
      <FinalCTA />
      <LandingFooter />
    </div>
  );
};

export default Home;
